import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import CompanyBookTask from '@/model/CompanyBookTask'
import Paging from "biz-ts/src/api/Paging";
import {BasePqForm} from "biz-ts/src/api/Paging";

@Singleton
export default abstract class CompanyBookTaskApi {

    abstract paging(form: CbookTaskPqForm): Promise<Paging<CompanyBookTask>>
}

class CompanyBookTaskApiImpl extends BaseApi implements CompanyBookTaskApi {

    protected urlPrefix = 'company/book/task'

    paging(form: CbookTaskPqForm): Promise<Paging<CompanyBookTask>> {
        return this.axios.get('paging', {params: form})
    }
}

Container.bind(CompanyBookTaskApi).to(CompanyBookTaskApiImpl)


export class CbookTaskPqForm extends BasePqForm {
    cbookId!: string

    constructor(cbookId: string) {
        super();
        this.cbookId = cbookId;
    }
}
